import { Event } from '../../shared/models/event';

export type ManagerInviteType = 'FIRST_TEAM' | 'RESERVE' | 'ALL' | 'REMINDER';
export interface ManagerInviteOption { type: ManagerInviteType; count: number; label: string; icon: string; }

export function managerInviteOptions(event: Event): ManagerInviteOption[] {
  if (!event?.viewedByManager || event.active === false || event.cancelled || event.incompleteSetup) return [];
  const options: ManagerInviteOption[] = [
    { type: 'FIRST_TEAM', count: 0, label: 'notifications.firstTeam', icon: 'match.notifications' },
    { type: 'RESERVE', count: 0, label: 'notifications.reserves', icon: 'match.notify.reserve' },
    { type: 'ALL', count: 0, label: 'notifications.allPlayers', icon: 'match.notifications' },
    { type: 'REMINDER', count: 0, label: 'notifications.remindInvited', icon: 'match.status.notAnswered' }
  ];
  return options.map(option => ({ ...option, count: event.managerHome
    ? option.type === 'REMINDER' ? event.managerHome.notAnsweredCount || 0
      : event.managerHome.inviteAudiences?.find(audience => audience.type === option.type)?.eligibleCount || 0
    : (event.playerEventInfos || []).filter(pei => pei.player && pei.player.active !== false && !!pei.player.email
      && pei.player.playerType !== 'GUEST' && !pei.player.guest && pei.teamMemberType !== 'CANDIDATE'
      && (option.type === 'REMINDER' ? pei.status === 'NOT_ANSWERED' && !pei.reminderSentAt
        : pei.status === 'NOT_NOTIFIED' && !pei.invitationSentAt && (option.type === 'ALL' || pei.teamMemberType === option.type))).length
  })).filter(option => option.count > 0);
}
